import pic from '../../assets/pareto/Picture2.png'
import pic1 from '../../assets/pareto/Picture3.png'
import pic2 from '../../assets/pareto/Picture4.png'
import pic3 from '../../assets/pareto/Picture5.png'
import pic4 from '../../assets/pareto/Picture6.png'
import pic5 from '../../assets/pareto/Picture7.png'
import pic6 from '../../assets/pareto/Picture8.png'
import pic7 from '../../assets/pareto/Picture9.png'
import pic8 from '../../assets/pareto/Picture10.png'
import pic9 from '../../assets/pareto/Picture11.png'
import pic10 from '../../assets/pareto/Picture12.png'
import pic11 from '../../assets/pareto/Picture13.png'

export const goldenRules = () => {

    return [
        {
            sectionName: "Situações de risco",
            picture: pic,
            rules: [
                { id: 1, label: "Smoke outside designated area" },
                { id: 2, label: "Work or drive under the influence of alcohol or drugs" },
                { id: 3, label: "Downgraded situation" },
                { id: 4, label: "Start-up and shutdown procedure" }
            ]
        },
        {
            sectionName: "Circulação",
            picture: pic1,
            rules: [
                { id: 5, label: "Exceed the speed limit" },
                { id: 6, label: "Use of mobile phone while driving" },
                { id: 7, label: "Use of designated pedestrian paths and handrails" }
            ]
        },
        {
            sectionName: "Gestos, posturas e ferramentas",
            picture: pic2,
            rules: [
                { id: 8, label: "Defective tools not intended for the task" },
                { id: 9, label: "Tools under conditions that exceed the manufacture's specified design limits" },
                { id: 10, label: "Tool not specified in the work permit and adapt of body mechanics to the tool" }
            ]
        },
        {
            sectionName: "Equipamentos de protecção individual",
            picture: pic3,
            rules: [
                { id: 11, label: "Cross a barrier or reposition protective equipment without authorisation" },
                { id: 12, label: "Not wear designated PPE for the area and task" }
            ]
        },
        {
            sectionName: "Permissão de trabalho",
            picture: pic4,
            rules: [
                { id: 13, label: "Works without an approved work permit" },
                { id: 14, label: "Work permit not re-issued when conditions on the original WP changed or the work procedure" }
            ]
        },
        {
            sectionName: "Operações de elevação",
            picture: pic5,
            rules: [
                { id: 15, label: "Walk or stand under a suspended work" },
                { id: 16, label: "Risk assessment, lift plan, area mark out not compliant" },
                { id: 17, label: "The load is not securely slung and bundled" }
            ]
        },
        {
            sectionName: "Sistemas alimentados por energia",
            picture: pic6,
            rules: [
                { id: 18, label: "Energy and fluid sources have not been isolated" },
                { id: 19, label: "Isolations, locks and tags" }
            ]
        },
        {
            sectionName: "Espaços confinados",
            picture: pic7,
            rules: [
                { id: 20, label: "Entering in a confined space without checking isolations and all atmospheric hazards" },
                { id: 21, label: "Atmospheric measurement are not on site" }
            ]
        },
        {
            sectionName: "Trabalhos de escavação",
            picture: pic8,
            rules: [
                { id: 22, label: "Machinery or spoil pipe within one meter of a trench being excavated" },
                { id: 23, label: "Excavation areas not marked and underground structures not identified" }
            ]
        },
        {
            sectionName: "Trabalhos em altura",
            picture: pic9,
            rules: [
                { id: 24, label: "Work under or near power lines without respecting the minimum safe clearance distance" },
                { id: 25, label: "Work on building or tank roofs without first checking their integrity and ensuring that the appropriate protective devices have been installed" },
                { id: 26, label: "Tools below 2 meters during works at height" },
                { id: 27, label: "Safety harness not safety anchored" },
                { id: 28, label: "Scaffolding that is not fit for purpose and not inspected" }
            ]
        },
        {
            sectionName: "Trabalhos a quente",
            picture: pic10,
            rules: [
                { id: 29, label: "Technical or organizational changes without getting prior authorization" },
                { id: 30, label: "Presence of flammable substances and ignition sources" }
            ]
        },
        {
            sectionName: "Linha de perigo",
            picture: pic11,
            rules: [
                { id: 31, label: "Moving objects are out in places" },
                { id: 32, label: "Simultaneous operations or co-activities without completing a preliminary field check" }
            ]
        }
    ]
}

export const toMakeReports = [
    {
        sectionId: "1",
        excelRowStart: 4,
        sectionName: "Situações de risco",
        rules: [1, 2, 3, 4]
    },
    {
        sectionId: "2",
        excelRowStart: 9,
        sectionName: "Circulação",
        rules: [5, 6, 7]
    },
    {
        sectionId: "3",
        excelRowStart: 13,
        sectionName: "Gestos, posturas e ferramentas",
        rules: [8, 9, 10]
    },
    {
        sectionId: "4",
        excelRowStart: 17,
        sectionName: "Equipamentos de protecção individual",
        rules: [11, 12]
    },
    {
        sectionId: "5",
        excelRowStart: 20,
        sectionName: "Permissão de trabalho",
        rules: [13, 14]
    },
    {
        sectionId: "6",
        excelRowStart: 23,
        sectionName: "Operações de elevação",
        rules: [15, 16, 17]
    },
    {
        sectionId: "7",
        excelRowStart: 27,
        sectionName: "Sistemas alimentados por energia",
        rules: [18, 19]
    },
    {
        sectionId: "8",
        excelRowStart: 30,
        sectionName: "Espaços confinados",
        rules: [20, 21]
    },
    {
        sectionId: "9",
        excelRowStart: 33,
        sectionName: "Trabalhos de escavação",
        rules: [22, 23]
    },
    {
        sectionId: "10",
        excelRowStart: 36,
        sectionName: "Trabalhos em altura",
        rules: [24, 25, 26, 27, 28,]
    },
    {
        sectionId: "11",
        excelRowStart: 42,
        sectionName: "Trabalhos a quente",
        rules: [29, 30,]
    },
    {
        sectionId: "12",
        excelRowStart: 45,
        sectionName: "Linha de perigo",
        rules: [31, 32]
    }
]